import { render, staticRenderFns } from "./TraxTrainingProgramCrudForm.vue?vue&type=template&id=1c748025"
import script from "./TraxTrainingProgramCrudForm.vue?vue&type=script&lang=js"
export * from "./TraxTrainingProgramCrudForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports